import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'regional-selector-button',
  styleUrl: 'regional-selector-button.css',
  shadow: false,
})
export class RegionalSelectorButton {

  @Prop() buttonLabel: string;

  // Events
  @Event() private buttonAction: EventEmitter;

  handleAction() {
    this.buttonAction.emit();
  }

  render() {
    return (
      <button type="button"
        class="rsm-confirm-button-style"
        onClick={this.handleAction.bind(this)}>
        {this.buttonLabel}
      </button>
    );
  }

}
